(($) => {

    const scrollOffset = 30;

    $(document).on('click', '.toc-header', (e) => {
        e.preventDefault();

        const header = $(e.target);
        const tableOfContent = header.closest('.table-of-content');

        tableOfContent.toggleClass('show');
    });

    $(document).on('click', '.table-of-content .toc-item > a', (e) => {
        e.preventDefault();

        const a = $(e.target);
        const targetHeading = $(a.attr('href'));

        if (targetHeading.length > 0) {
            const scrollTop = Math.floor(targetHeading.offset().top - scrollOffset);
            $('html, body').stop().animate({ scrollTop: scrollTop }, 400);
        }
    });


    const tocHeadings = $('.toc-heading');
    let lastActiveHeading = null;

    const doActivateTocItem = (activeHeading) => {

        const headingId = $(activeHeading).attr('id');
        if (headingId) {
            const tocAnchor = $(`[href="#${headingId}"]`);
            tocAnchor.closest('.toc-list').find('.toc-item').removeClass('toc-active-item');
            tocAnchor.closest('.toc-item').addClass('toc-active-item');
        }
    }

    $(window).on('scroll', () => {

        let activeHeading = null;

        const winScrollTop = $(window).scrollTop();

        tocHeadings.each((i, heading) => {

            // Get position of the element that relative to the window.
            const posTop = Math.floor($(heading).offset().top - winScrollTop - scrollOffset);

            if (posTop <= 0) {
                activeHeading = heading;
            }
        });

        if (activeHeading && activeHeading !== lastActiveHeading) {

            doActivateTocItem(activeHeading);

            // Remember last active heading
            lastActiveHeading = activeHeading;
        }
    });
})(jQuery);
